export const HIGHLIGHT_MODE = {
  FILTER_FIRST: 'normal',
  FILTER_LAST: 'reverse',
}
